import React from 'react';

export interface InlineAlertProps {
  message: string;
  variant?: 'error' | 'info' | 'success';
  className?: string;
}

const variantClasses = {
  error: 'bg-error-50 dark:bg-error-900/20 border-error-200 dark:border-error-800 text-error-600 dark:text-error-400',
  // P1-02: was bg-primary-50 on border-primary-200, which resolved to
  // #F8F9FA on #E1E5E9 — a near-white alert with no visible fill. Repointed to the
  // same #EDEBF2 family as the Chip brand fill, and given the dark: classes it was
  // the only variant missing.
  info: 'bg-[#EDEBF2] dark:bg-primary-900/20 border-[#DFDAE8] dark:border-primary-800 text-primary-700 dark:text-primary-300',
  success:
    'bg-success-50 dark:bg-success-900/20 border-success-200 dark:border-success-800 text-success-700 dark:text-success-400',
};

const InlineAlert: React.FC<InlineAlertProps> = ({
  message,
  variant = 'error',
  className = '',
}) => {
  return (
    <div className={`border rounded-lg p-4 ${variantClasses[variant]} ${className}`}>
      <p className="text-sm">{message}</p>
    </div>
  );
};

export default InlineAlert;
